import React from 'react'
import { LayoutContext } from './LayoutProvider'

function useLayout() {
  const context = React.useContext(LayoutContext)
  return context
}

export default useLayout
